import { useCallback, useState } from "react";
import { handleClaimAction } from "@actions/ClaimsAction";
import { useAppConfig } from "@context/AppConfigContext";
import { toastService } from "@utils/index";

export const REJCTION_REASONS = [
  {
    value: "Claim raised after 48 hours",
    label: "Claim raised after 48 hours",
  },
  { value: "Status not Waitlisted", label: "Status not Waitlisted" },
  {
    value: "Invalid or duplicate claim data",
    label: "Invalid or duplicate claim data",
  },
  { value: "OTHERS", label: "Others" },
];

// API call for Claim Action

export const handleClaimActionAPI = async (payload) => {
  try {
    const response = await handleClaimAction(payload);

    return {
      data: response,
      success: true,
    };
  } catch (err) {
    return {
      success: false,
      data: [],
      error: err || "Failed to update the claim",
    };
  }
};

export const useClaimActionData = ({ handleCancelAction, loadClaimsData }) => {
  const [selectedRejectionReason, setSelectedRejectionReason] = useState("");
  const [remarks, setRemarks] = useState("");
  const [claimActionLoading, setClaimActionLoading] = useState(false);

  const { user, selectedClient } = useAppConfig();

  const handleRejectionReasonChange = useCallback((status) => {
    setSelectedRejectionReason(status);
  }, []);

  const handleRemarksChange = useCallback((event) => {
    setRemarks(event?.target?.value);
  }, []);

  const claimDecisionSubmitHandler = useCallback(
    async (claimData, claimAction) => {
      setClaimActionLoading(true);

      const payload = {
        claim_id: claimData?.claim_id,
        decision: claimAction === "reject" ? "REJECTED" : "APPROVED",
        rejection_reason: selectedRejectionReason,
        remark: remarks,
        user_id: user?.user?.id,
        email: user?.user?.email,
        clientname: selectedClient?.clientName,
      };

      const response = await handleClaimActionAPI(payload);

      if (response.success) {
        loadClaimsData();
        toastService.success(response.data.message);
      } else {
        toastService.error(response.error.message);
      }

      setClaimActionLoading(false);
      handleCancelAction();
    },
    [
      selectedRejectionReason,
      handleCancelAction,
      remarks,
      user,
      loadClaimsData,
      selectedClient?.clientName,
    ],
  );

  return {
    selectedRejectionReason,
    handleRejectionReasonChange,
    remarks,
    handleRemarksChange,
    claimDecisionSubmitHandler,
    claimActionLoading,
  };
};
